document.addEventListener('turbolinks:load', function() {
  if(window.ga && ga.loaded) {
    gtag('config', 'UA-74187457-1')
  }
});

document.addEventListener("turbolinks:load", function(event) {

  let applyToModal = document.getElementsByClassName("apply-basket")[0];
	const ModalCard = document.getElementsByClassName("main-modal-basket")[0];
	const ModalCardOverlay = document.getElementsByClassName("main-modal-overlay");
	const ModalCloseBtn = document.getElementsByClassName("main-modal-content-close");
    const body = document.getElementsByTagName("body")[0];

	applyToModal.onclick = function() {
        ModalCard.classList.add("main-modal-visible");
        body.classList.add("body-modal-open");
    }

    for(let i = 0; i < ModalCardOverlay.length; i++){

        ModalCardOverlay[i].addEventListener("click",function(){
            ModalCard.classList.remove("main-modal-visible");
            deleteModal.classList.remove("main-modal-visible");
            body.classList.remove("body-modal-open");
        })
    }

    for(let i = 0; i < ModalCloseBtn.length; i++){

        ModalCloseBtn[i].addEventListener("click",function(){
            ModalCard.classList.remove("main-modal-visible");
            deleteModal.classList.remove("main-modal-visible");
            body.classList.remove("body-modal-open");
        })
    }

    //delete modal
    //const deleteBtn = document.getElementsByClassName("basket-row-field basket-row-field-delete");
    const deleteModal = document.getElementsByClassName("main-modal-delete")[0];
    const deleteProdBtn = document.getElementsByClassName("delete-btn")[0];
    const cancelBtn = document.getElementsByClassName("cancel-btn")[0];

    let productRows = Array.from(document.getElementsByClassName("basket-row"));
    let productId = "";

    let obj = {
        "product-1" : 3,
        "product-2" : 5
    }

    deleteProdBtn.onclick = function() {

        productRows.forEach(item => {
          if (item.dataset.id === productId) {
            item.remove();
            deleteModal.classList.remove("main-modal-visible");
            body.classList.remove("body-modal-open");
          }
        });

        //fetch request
    }

    //for(let i = 0; i < deleteBtn.length; i++){

        //deleteBtn[i].addEventListener("click",function(){
            //productId = this.closest(".basket-row").dataset.id;
            //deleteModal.classList.add("main-modal-visible");
            //body.classList.add("body-modal-open");
        //})
    //}

    cancelBtn.onclick = function() {
        deleteModal.classList.remove("main-modal-visible");
        body.classList.remove("body-modal-open");
    }

    //product counter


})
